import { featuredStories } from "@/mocks/news";

export default function FeaturedSection() {
  const [lead, ...rest] = featuredStories;

  return (
    <section id="featured" className="w-full bg-background-100 py-12 md:py-16">
      <div className="mx-auto w-full max-w-[1280px] px-4 md:px-8">
        <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="inline-flex items-center gap-2 text-xs font-medium tracking-wide text-primary-600">
              <i className="ri-fire-line" aria-hidden />
              今日首发 · 编辑盯了一整夜
            </span>
            <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              三条还在动的一手线索
            </h2>
          </div>
          <a
            href="#latest"
            className="inline-flex shrink-0 items-center gap-1 whitespace-nowrap text-sm text-foreground-600 transition-colors hover:text-primary-600"
          >
            查看全部最新爆料
            <i className="ri-arrow-right-line" aria-hidden />
          </a>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 lg:grid-cols-2">
          <article className="group relative min-h-[320px] overflow-hidden rounded-lg md:min-h-[480px]">
            <img
              src={lead.cover}
              alt={`${lead.title} — ${lead.category}首发配图`}
              className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.03]"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950 via-foreground-950/50 to-transparent" />
            <div className="relative z-10 flex h-full flex-col justify-end p-5 md:p-7">
              <div className="flex flex-wrap items-center gap-2">
                <span className="rounded-md bg-primary-500 px-2 py-1 text-[11px] font-medium text-background-50">
                  独家首发
                </span>
                <span className="rounded-md bg-background-50/15 px-2 py-1 text-[11px] text-background-50 backdrop-blur">
                  {lead.category}
                </span>
                <span className="text-[11px] text-background-100/70">{lead.publishedAt}</span>
              </div>
              <a href="#latest" className="mt-3 block">
                <h3 className="font-heading text-xl font-black leading-snug text-background-50 md:text-3xl">
                  {lead.title}
                </h3>
              </a>
              <p className="mt-3 line-clamp-2 max-w-2xl text-sm leading-relaxed text-background-100/85">
                {lead.excerpt}
              </p>
              <div className="mt-5 flex flex-wrap items-center gap-4 text-xs text-background-100/70">
                <span className="flex items-center gap-1">
                  <i className="ri-eye-line" aria-hidden />
                  {lead.reads}
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-chat-3-line" aria-hidden />
                  {lead.comments} 条讨论
                </span>
                <span className="flex items-center gap-1 text-secondary-300">
                  <i className="ri-refresh-line" aria-hidden />
                  {lead.status}
                </span>
              </div>
            </div>
          </article>

          <div className="flex flex-col gap-5">
            {rest.map((item) => (
              <article
                key={item.id}
                className="group flex flex-1 flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 sm:flex-row"
              >
                <div className="relative h-44 w-full shrink-0 overflow-hidden sm:h-auto sm:w-48 md:w-56">
                  <img
                    src={item.cover}
                    alt={`${item.title} — ${item.category}首发配图`}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.04]"
                  />
                  <span className="absolute left-3 top-3 rounded-md bg-primary-500 px-2 py-1 text-[11px] font-medium text-background-50">
                    独家
                  </span>
                </div>
                <div className="flex flex-1 flex-col p-5">
                  <div className="flex items-center gap-2 text-xs">
                    <span className="rounded bg-accent-100 px-2 py-0.5 font-medium text-accent-900">
                      {item.category}
                    </span>
                    <span className="text-foreground-500">{item.publishedAt}</span>
                  </div>
                  <a href="#latest" className="mt-2.5 block">
                    <h3 className="line-clamp-2 font-heading text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600 md:text-lg">
                      {item.title}
                    </h3>
                  </a>
                  <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">
                    {item.excerpt}
                  </p>
                  <div className="mt-auto flex items-center gap-3 pt-4 text-xs text-foreground-500">
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line" aria-hidden />
                      {item.reads}
                    </span>
                    <span className="ml-auto flex items-center gap-1 text-primary-600">
                      <i className="ri-time-line" aria-hidden />
                      {item.status}
                    </span>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}